import { httpsCallable } from "firebase/functions";
import { functionsClient } from "./firebase";
import type { ReportReason } from "./reports";

const getIdentityBlockStatusCallable = httpsCallable<
  { targetIdentityId: string },
  { blocked: boolean }
>(functionsClient, "getIdentityBlockStatus");

const blockIdentityCallable = httpsCallable<
  { targetIdentityId: string },
  { ok: true }
>(functionsClient, "blockIdentity");

const unblockIdentityCallable = httpsCallable<
  { targetIdentityId: string },
  { ok: true }
>(functionsClient, "unblockIdentity");

const reportIdentityMessagingCallable = httpsCallable<
  {
    reporterIdentityId: string;
    targetIdentityId: string;
    conversationId?: string;
    messageId?: string;
    reason: ReportReason;
    details?: string;
  },
  { ok: true; reportId: string }
>(functionsClient, "reportIdentityMessaging");

const reportIdentityGroupMessageCallable = httpsCallable<
  {
    reporterIdentityId: string;
    groupId: string;
    messageId: string;
    reason: ReportReason;
    details?: string;
  },
  { ok: true; reportId: string }
>(functionsClient, "reportIdentityGroupMessage");

export async function getIdentityBlockStatus(targetIdentityId: string) {
  return (await getIdentityBlockStatusCallable({ targetIdentityId })).data.blocked;
}

export async function blockIdentity(targetIdentityId: string) {
  return (await blockIdentityCallable({ targetIdentityId })).data;
}

export async function unblockIdentity(targetIdentityId: string) {
  return (await unblockIdentityCallable({ targetIdentityId })).data;
}

export async function reportIdentityMessaging(input: {
  reporterIdentityId: string;
  targetIdentityId: string;
  conversationId?: string;
  messageId?: string;
  reason: ReportReason;
  details?: string;
}) {
  return (await reportIdentityMessagingCallable(input)).data;
}

export async function reportIdentityGroupMessage(input: {
  reporterIdentityId: string;
  groupId: string;
  messageId: string;
  reason: ReportReason;
  details?: string;
}) {
  return (await reportIdentityGroupMessageCallable(input)).data;
}
